import { styled } from '@material-ui/core';
import { Events, Linked } from '@type-r/models';
import * as queryString from 'query-string';
import { ComponentProps, FunctionComponent, JSXElementConstructor } from 'react';

export const colors = {
    green : '#01C38D',
    blue : '#0099E1',
    yellow : '#FFBC00',
    red : '#FF274B',
    grey: '#728A97',
    lightGrey: '#CBD9E3',
    orange: '#FFA500'
}

/**
 * Add markdown description to the storybook's story.
 */
export function description( story : Function & { story? : any }, markdown : string ){
    story.story = { parameters: { docs: { storyDescription: markdown }}}
}

function getPath() {
    return window.location.pathname.split( '/' );
}

export function getParamsFromPath( n = 2 ){
    return getPath().slice( n );
}

export function getIdFromPath( n ){
    return getPath()[ n ];
}

export function useLinkedLocation( n : number, defaultValue = '', parent = '' ){
    const value = getIdFromPath(n);
    
    if (!value && defaultValue) {
        navigate( value || getPath().includes( parent ) ? defaultValue : parent + '/' + defaultValue, n );
    }

    return Linked.value(
        value || defaultValue,
        x => {
            if( x ){
                // TODO: Dirty hotfix for INM-307. Do it better.
                navigate( value || getPath().includes( parent ) ? x : parent + '/' + x, n );
            }
            else{
                Events.trigger( 'navigate', getPath().slice( 0, n ).join( '/' ) );
            }
        }
    );
}

export function toLinkedBoolean<T>( linked : Linked<T> ){
    return Linked.value( Boolean( linked.value ), x => {
        if( !x ){
            linked.null();
        }
    })
}

export function getBackPath(){
    const path = window.location.pathname.split('/');
    path.pop();
    return path.join('/')
}

export function back(){
    Events.trigger( 'navigate', getBackPath() );
}

export function navigate( path : string, n : number = 2, anchor = undefined, addReturnUrl = false ){
    let params;
    if (addReturnUrl) {
        params = { returnUrl: `${window.location.pathname}${window.location.search}` };
    }
    Events.trigger( 'navigate', window.location.pathname.split( '/' ).slice( 0, n ).join('/') + '/' + path, anchor, params );
}

export function jumpToAnchor(hash: string) {
    if (window.location.hash === '#' + hash) {
        window.location.hash = '';
    }
    window.location.hash = hash;
}

export const isEmbeddedApp = () => Boolean( window.location.pathname.match( /^\/\w*-app/ ) );
export const getAppRoot = () => '/' + getIdFromPath( 1 );
export const getAppHref = ( path : string ) => getAppRoot() + path;

export const div = styled( 'div' );
export const span = styled( 'span' );

export type ExtendProps<C extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>,EP> =
    FunctionComponent<ComponentProps<C> & EP>

export function getQueryParam(key) {
    const parsed = queryString.parse(location.search);
    return parsed[key];
}

export function useLinkedQueryParam(key){
    return Linked.value(
        getQueryParam(key),
        param => {
            const parsed = queryString.parse(location.search);

            if(param){
                parsed[key] = param;
            }
            Events.trigger( 'navigate', window.location.pathname, null, parsed);
        }
    );
}